//Formats date to hh:mm dd.MM.yyyy string
const formatDate = (dateOrDateString: Date | string): string => {
  if (typeof dateOrDateString === "string") {
    if (dateOrDateString === "") return "";
    return dateStringToDisplay(dateOrDateString);
  } else {
    return dateToDisplay(dateOrDateString);
  }
};

const dateStringToDisplay = (dateString: string) => {
  const date = new Date(dateString);
  return dateToDisplay(date);
};

const dateToDisplay = (date: Date) => {
  const localeDate = date.toLocaleDateString("no-NB");
  const time = date.toLocaleTimeString("no-NB");
  const formattedTime = time.split(":").slice(0, 2).join(":");
  return `${localeDate} ${formattedTime}`;
};

export default formatDate;
